import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Card, CardContent, Rating, Avatar } from '@mui/material';
import { AppBar, Toolbar, IconButton, Box } from '@mui/material';
import { List, ListItem, ListItemText } from '@mui/material';
import { Drawer, Divider, Typography } from '@mui/material';
import { Container, Link } from '@mui/material';

import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";

import MenuIcon from '@mui/icons-material/Menu';
import InfoIcon from '@mui/icons-material/Info';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import ScheduleIcon from '@mui/icons-material/Schedule';
import EmailIcon from '@mui/icons-material/Email';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import InstagramIcon from '@mui/icons-material/Instagram';
import WorkIcon from '@mui/icons-material/Work';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import './Page.css';

export const GoogleTranslateWidget = ({ containerId = 'google_translate_element' }) => {
  const initializedRef = useRef(false);

  useEffect(() => {
    if (!window.googleTranslateElementInit) {
      window.googleTranslateElementInit = () => {
        initializedRef.current = true;
        new window.google.translate.TranslateElement(
          { pageLanguage: 'en' },
          containerId
        );
      };

      // Load the script once
      const script = document.createElement('script');
      script.src =
        'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      script.async = true;
      document.body.appendChild(script);
    } else if (window.google?.translate?.TranslateElement && !initializedRef.current) {
      // In case script is already loaded, initialize immediately
      initializedRef.current = true;
      new window.google.translate.TranslateElement(
        { pageLanguage: 'en' },
        containerId
      );
    }
  }, [containerId]);

  return <div id={containerId}></div>;
};

export function Navbar2() {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const toggleDrawer = () => setDrawerOpen(open => !open);

    const menuItems = [
        { label: 'About Us', href: '/#AboutUs2' },
        { label: 'Services', href: '/#Services2' },
        { label: 'Gallery', href: '/#Gallery' },
        { label: 'Book Online', href: 'https://web.getsquire.com/brands/the-lobby' },
        { label: 'Careers', href: '/Careers' },
    ];

    const InfoItem = ({ icon: Icon, text }) => (
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <Icon sx={{ mr: 1 }} /> <Typography>{text}</Typography>
        </Box>
    );

    return (
        <>
            {/* position="sticky" for video */}
            <AppBar position="sticky" color="transparent" elevation={0} sx={{ backdropFilter: 'blur(8px)', color: '#fff', zIndex: 1300 }}>
                <Toolbar sx={{ position: 'relative', minHeight: 64 }} >
                    <IconButton edge="start" color="inherit" aria-label="menu" onClick={toggleDrawer} size="large" sx={{ position: 'absolute', left: { xs: 16, sm: 16, md: 50, lg: 100 } }}>
                        <MenuIcon />
                    </IconButton>

                    <Box component="a" href="/"
                        sx={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)', display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                        <Box component="img" src="./images/output_image3.png" alt="Logo" sx={{ height: 48 }} />
                    </Box>
                    <Box sx={{ position: 'absolute', right: { xs: 16, sm: 16, md: 50, lg: 100 } }}>
                        <a href="https://web.getsquire.com/brands/the-lobby" className="n-link text-light BOOK-NOW"></a>
                    </Box>
                </Toolbar>
            </AppBar>

            <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer} PaperProps={{ sx: { bgcolor: '#121212', color: 'white', width: 320, px: 2, py: 3 } }}>
                <Box component="a" href="/" onClick={toggleDrawer} sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
                    <Box component="img" src="./images/output_image3.png" alt="Logo" sx={{ maxWidth: '100%', height: 80 }} />
                </Box>

                <List>
                    {menuItems.map(({ label, href }) => (
                        <ListItem
                            button
                            component="a"
                            href={href}
                            key={label}
                            onClick={toggleDrawer}
                            sx={{
                                borderRadius: 1, mb: 1, fontSize: '0.1rem',
                                // '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' } 
                            }}
                            className="custom-link"
                        >
                            <ListItemText primary={label} />
                        </ListItem>
                    ))}
                </List>

                <Divider sx={{ my: 3, borderColor: 'rgba(255,255,255,0.2)' }} />

                <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <InfoIcon /> Store Information
                </Typography>

                <InfoItem icon={LocationOnIcon} text="Unit 22 - 255 Dundas St E, Waterdown, ON L8B 0E5" />
                <InfoItem icon={PhoneIcon} text="+1 289-895-7600" />
                
                {/* <section id="Services2" className="py-2" style={{ background: 'linear-gradient(180deg, rgba(25,25,25,1) 0%, rgba(25,25,25,1) 60%, rgba(0,0,0,1) 100%)' }}>
                    <div className="container">
                        <center>
                            <GoogleTranslateWidget containerId="translate-widget-top" />
                        </center>
                    </div>
                </section> */}
                {/* <div id="google_translate_element"></div> */}
            </Drawer>
        </>
    );
}

export const ServiceAccordion = ({ title, services }) => {
    const [activeIndex, setActiveIndex] = useState(null);

    const handleToggle = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div className="accordion custom-accordion" id={title}>
            {services.map((service, index) => (
                <div className="card" key={index} style={{ borderRadius: 0, border: 'none', background: '0 0' }}>
                    <div className="card-header" id={`heading${index}`} style={{ borderRadius: '15px 15px 0px 0px', borderBottom: '1px solid #fff', padding: '0px' }}>
                        <h5 className="mb-0">
                            <button
                                // className="btn btn-link collapsed"
                                className={`btn btn-link ${activeIndex === index ? '' : 'collapsed'}`}
                                type="button"
                                onClick={() => handleToggle(index)}
                                aria-expanded={activeIndex === index}
                                aria-controls={`collapse${index}`}
                                style={{
                                    color: '#fff',
                                    textDecoration: 'none'
                                }}
                            >
                                <p style={{ margin: 0 }} >{service.name}</p>
                                <span>{service.price}</span>
                            </button>
                        </h5>
                    </div>
                    <div
                        id={`collapse${index}`}
                        className={`collapse ${activeIndex === index ? 'show' : ''}`}
                        aria-labelledby={`heading${index}`}
                        data-parent={`#${title}`}
                    >
                        {/* <div className="card-body">
                            <h3>{`${service.name} - ${service.price}`}</h3>
                            <h6>Time required: {service.time}</h6>
                            <p>{service.description}</p>
                            <p>* Price shown is not inclusive of 13% HST.</p>
                        </div> */}
                        <div className="card-body">
                            {/* Header */}
                            <div className="card-header mb-2">
                                <h3 className="card-title mb-1">
                                    {service.name}
                                </h3>
                                <span className="h5">
                                    {service.price}
                                </span>
                            </div>

                            {/* Details */}
                            <div className="card-details mb-2">
                                <h6 className="mb-2">
                                    Time Required: <span className="text-primary">{service.time}</span>
                                </h6>
                                {service.description && (
                                    <p className="card-text">{service.description}</p>
                                )}
                            </div>

                            {/* Footer */}
                            <div className="card-footer text-italic small">
                                * Price shown is not inclusive of 13% HST.
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

// export const ServiceAccordion = ({ title, services }) => {
//   const [activeIndex, setActiveIndex] = useState(null);

//   const handleToggle = index => {
//     setActiveIndex(activeIndex === index ? null : index);
//   };

//   return (
//     <Box
//       id={title}
//       sx={{
//         width: '100%',
//         maxWidth: 600,
//         mx: 'auto',
//         bgcolor: 'transparent',
//       }}
//     >
//       {services.map((service, index) => (
//         <Box
//           key={index}
//           sx={{
//             borderRadius: 2,
//             mb: 2,
//             bgcolor: activeIndex === index ? 'rgba(255,255,255,0.1)' : 'transparent',
//             border: '1px solid rgba(255,255,255,0.3)',
//             cursor: 'pointer',
//             transition: 'background-color 0.3s ease',
//           }}
//           onClick={() => handleToggle(index)}
//           aria-expanded={activeIndex === index}
//           role="button"
//           tabIndex={0}
//           onKeyDown={e => {
//             if (e.key === 'Enter' || e.key === ' ') {
//               handleToggle(index);
//             }
//           }}
//         >
//           <Box
//             sx={{
//               px: 2,
//               py: 1.5,
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center',
//               userSelect: 'none',
//               color: '#fff',
//             }}
//           >
//             <Typography variant="subtitle1" fontWeight="bold">
//               {service.name}
//             </Typography>
//             <Typography variant="subtitle1" fontWeight="bold">
//               {service.price}
//             </Typography>
//           </Box>

//           {activeIndex === index && (
//             <Box
//               sx={{
//                 px: 2,
//                 pb: 2,
//                 pt: 1,
//                 color: 'rgba(255,255,255,0.8)',
//                 fontSize: '0.9rem',
//                 lineHeight: 1.4,
//               }}
//             >
//               <Typography sx={{ mb: 1 }}>
//                 <strong>Time Required:</strong> {service.time}
//               </Typography>
//               {service.description && (
//                 <Typography sx={{ mb: 1 }}>{service.description}</Typography>
//               )}
//               <Typography fontStyle="italic" fontSize="0.8rem">
//                 * Price shown is not inclusive of 13% HST.
//               </Typography>
//             </Box>
//           )}
//         </Box>
//       ))}
//     </Box>
//   );
// };

export const CustomerReview = ({ name, date, description }) => {
    return (
        <Card sx={{ position: 'relative', boxShadow: 2,
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    '&:hover': {
                        transform: 'translateY(-8px)',
                        boxShadow: 6,
                }, 
            }}>
            <Avatar sx={{ position: 'absolute', top: (theme) => theme.spacing(2), right: (theme) => theme.spacing(2), backgroundColor: 'transparent' }}>
                <img className='position-absolute' src="https://www.google.com/favicon.ico" alt="google" />
            </Avatar>
            <CardContent>
                <Typography variant="h6" component="div">{name}</Typography>
                <Typography variant="subtitle2" color="text.secondary" gutterBottom>{date}</Typography>
                <Rating name="read-only" value={5} readOnly size="small" />
                <Typography variant="body2" color="text.primary">{description}</Typography>
            </CardContent>
        </Card>
    );
};

export const Footer2 = () => {
    const [data, setData] = useState(null);
    useEffect(() => fetch("/data.json").then(res => res.json()).then(setData), []);
    if (!data) return <div>Loading...</div>;

    const InfoItem = ({ icon: Icon, text }) => (
        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <Icon sx={{ fontSize: 16, mr: 1 }} />
            <Typography variant="body2">{text}</Typography>
        </Box>
    );

    return (
        <Box
            component="footer"
            sx={{
                zIndex: 1000,
                backdropFilter: "blur(5px)",
                backgroundColor: "rgba(0,0,0,0.5)",
                color: "#fff",
                pt: 6,
                pb: 6,
                borderTop: "1px solid rgba(255,255,255,0.1)",
            }}
        >
            <Container>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        justifyContent: "space-between",
                        // px: -50
                    }}
                >
                    <Box sx={{ mb: 4, flex: 1, px: { md: 2 } }}>
                        <Typography variant="h6" sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                            <LocationOnIcon sx={{ fontSize: 20, mr: 1 }} /> Our Location
                        </Typography>
                        <Box component="iframe"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d43389.054594535526!2d-79.95333219738939!3d43.3478059088877!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882c9d960b6de769%3A0xca6aa4a07abfb89c!2sThe%20Lobby%20Barbershop!5e0!3m2!1sen!2sca!4v1743186074015!5m2!1sen!2sca"
                            width="100%" height="65%" frameBorder="0" allowFullScreen aria-hidden="false" tabIndex="0" sx={{ border: 0, mb: 2 }}
                        />
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Box component="img" src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/Flag_of_Canada_%28leaf%29.svg/1280px-Flag_of_Canada_%28leaf%29.svg.png" alt="Canadian Flag" sx={{ width: 24, height: 24, mr: 1 }} />
                            <Typography variant="body2">Proudly Canadian</Typography>
                        </Box>
                    </Box>

                    <Box sx={{ mb: 4, flex: 1, px: { md: 2 } }}>
                        <Typography variant="h6" sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                            <ScheduleIcon sx={{ fontSize: 20, mr: 1 }} /> Store Hours
                        </Typography>
                        {data.Times.map((text, i) => (
                            <InfoItem key={i} icon={CalendarTodayIcon} text={text} />
                        ))}

                        <Typography variant="h6" sx={{ display: "flex", alignItems: "center", mt: 3, mb: 2 }}>
                            <InfoIcon sx={{ fontSize: 20, mr: 1 }} /> Store Information
                        </Typography>
                        <InfoItem icon={LocationOnIcon} text="Unit 22 - 255 Dundas St E, Waterdown, ON L8B 0E5" />
                        <InfoItem icon={PhoneIcon} text="+1 289-895-7600" />
                    </Box>

                    <Box sx={{ mb: 4, flex: 1, px: { md: 2 } }}>
                        <Typography variant="h6" sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                            <WorkIcon sx={{ fontSize: 20, mr: 1 }} /> Careers
                        </Typography>
                        <Typography variant="body2">
                            Interested in joining our team? Email us at{" "}
                            <Link
                                href="mailto:info@thelobbybarbershop.ca"
                                sx={{ color: "#fff", textDecoration: "none", "&:hover": { textDecoration: "underline" } }}
                            >
                                careers@thelobbybarbershop.ca
                            </Link>{" "}
                            to explore career opportunities.
                        </Typography>

                        <Typography variant="h6" sx={{ display: "flex", alignItems: "center", mt: 4, mb: 1 }}>
                            <EmailIcon sx={{ fontSize: 20, mr: 1 }} /> Contact Us
                        </Typography>
                        <Typography variant="body2">
                            Questions? Email us at{" "}
                            <Link href="mailto:info@thelobbybarbershop.ca" sx={{ color: "#fff", textDecoration: "none", "&:hover": { textDecoration: "underline" } }}>
                                info@thelobbybarbershop.ca
                            </Link>
                        </Typography>
                    </Box>
                </Box>
            </Container>

            <Box sx={{ borderTop: "1px solid rgba(255,255,255,0.1)", mt: 4, py: 2 }}>
                <Container sx={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", alignItems: "center" }}>
                    <Typography variant="body2">&copy; {new Date().getFullYear()} The Lobby Barbershop</Typography>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        {/* <GoogleTranslateWidget containerId="translate-widget-top" /> */}
                        <Typography variant="body2">Follow Us:</Typography>
                        <Link href="https://www.instagram.com/thelobbybarbershop.ca/" target="_blank" rel="noopener noreferrer" sx={{ color: "#fff", ml: 2, fontSize: "1.2rem" }}>
                            <InstagramIcon fontSize="inherit" />
                        </Link>
                    </Box>
                </Container>
            </Box>
        </Box>
    );
};

export function GalleryCarousel({images}) {
    // const images = [
    //     "/images/carousel_one.png",
    //     "/images/carousel_two.png",
    //     "/images/carousel_three.jpg",
    // ];

    const [emblaRef, emblaApi] = useEmblaCarousel(
        { loop: true, align: "center" },
        [Autoplay({ delay: 3000 })]
    );
    const [selectedIndex, setSelectedIndex] = useState(0);

    const scrollPrev = useCallback(() => emblaApi?.scrollPrev(), [emblaApi]);
    const scrollNext = useCallback(() => emblaApi?.scrollNext(), [emblaApi]);
    const scrollTo = useCallback((index) => emblaApi?.scrollTo(index), [emblaApi]);

    useEffect(() => {
        if (!emblaApi) return;
        emblaApi.on("select", () =>
            setSelectedIndex(emblaApi.selectedScrollSnap())
        );
    }, [emblaApi]);

    return (
        <Box sx={{ position: "relative" }}>
            <Container maxWidth="xl">
                <Box sx={{ position: "relative", height: { xs: 300, sm: 400, md: 500 } }}>
                    <Box ref={emblaRef} sx={{ overflow: "hidden", height: "100%" }}>
                        <Box sx={{ display: "flex", height: "100%", gap: 2 }}>
                            {images.map((img, index) => (
                                <Box key={index} sx={{ flex: "0 0 80%", minWidth: 0, pl: 1 }}>
                                    <Box sx={{ height: "100%", borderRadius: 1, overflow: "hidden", border: "1px solid rgba(255,255,255,0.3)", transform: selectedIndex === index ? "scale(1.05)" : "scale(0.95)", transition: "transform 0.3s ease" }}>
                                        <Box component="img" src={img} alt={`Gallery ${index + 1}`} sx={{ width: "100%", height: "100%", objectFit: "cover", display: "block", filter: selectedIndex === index ? "none" : "grayscale(20%)" }} />
                                    </Box>
                                </Box>
                            ))}
                        </Box>
                    </Box>

                    <IconButton onClick={scrollPrev} sx={{ position: "absolute", left: 8, top: "50%", zIndex: 1, color: "white" }}>
                        <ChevronLeftIcon fontSize="large" />
                    </IconButton>
                    <IconButton onClick={scrollNext} sx={{ position: "absolute", right: 8, top: "50%", zIndex: 1, color: "white" }}>
                        <ChevronRightIcon fontSize="large" />
                    </IconButton>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "center", gap: 1, mt: 3 }}>
                    {images.map((_, i) => (
                        <Box key={i} onClick={() => scrollTo(i)} sx={{ width: i === selectedIndex ? 24 : 8, height: 8, borderRadius: i === selectedIndex ? 2 : "50%", bgcolor: i === selectedIndex ? "white" : "rgba(255,255,255,0.3)", cursor: "pointer", transition: "all 0.3s ease" }} />
                    ))}
                </Box>
            </Container>
        </Box>
    );
}
